import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import styles from "../AscRichTextEditor.module.scss";
import LoadInitialValuePlugin from "../plugins/LoadInitialValuePlugin/LoadInitialValuePlugin";
import classNames from "classnames";
import { editorConfig } from "../config/editorConfig";

interface AscRichTextViewerProps {
  className?: string;
  editorInputClass?: string;
  inferValue?: string;
  htmlValue?: string;
  jsonValue?: string;
}

export default function AscRichTextViewer({
  className,
  editorInputClass,
  inferValue,
  htmlValue,
  jsonValue,
}: AscRichTextViewerProps) {
  return (
    <LexicalComposer initialConfig={{ ...editorConfig, editable: false }}>
      <div
        className={classNames(
          styles["editor-container"],
          className
        )}
      >
        <div className={classNames(styles["editor-container"], className)}>
          <div className={classNames(styles["editor-inner"], styles.transparent, className)}>
            <RichTextPlugin
              contentEditable={
                <ContentEditable
                  className={classNames(
                    styles["editor-input"],
                    editorInputClass
                  )}
                />
              }
              placeholder={<div />}
              ErrorBoundary={LexicalErrorBoundary}
            />
            <LoadInitialValuePlugin
              inferString={inferValue}
              htmlString={htmlValue}
              jsonString={jsonValue}
            />
          </div>
        </div>
      </div>
    </LexicalComposer>
  );
}
